import { shared } from '@shared/_lang/en';
import { autoinformer } from '@autoinformer/_lang/en';
import { autocaller_v2 } from '@autocaller_v2/_lang/en';
import { predictive_connect } from '@predictive_connect/_lang/en';
import { call_tracking } from '@call-tracking/_lang/en';
import { core } from '@core/_lang/en';
import { prices } from '@prices/_lang/en';
import { db } from '@db/_lang/en';
import { integration } from '@integration/_lang/en';
import { mailer } from '@mailer/_lang/en';
import { notify } from '@notify/_lang/en';
import { payment } from '@payment/_lang/en';
import { pbx } from '@pbx/_lang/en';
import { phone_number } from '@phone-number/_lang/en';
import { referral } from '@referral/_lang/en';
import { verification } from '@verification/_lang/en';
import { voice } from '@voice/_lang/en';
import { amoWidget } from '@amo-widget/_lang/en';
import { integrations } from '@integrations/_lang/en';
import { hlr } from '@hlr/_lang/en';

import { validator } from '@shared/_lang/en/validator';

export default {
  shared,
  autoinformer,
  autocaller_v2,
  predictive_connect,
  core,
  prices,
  db,
  integration,
  mailer,
  notify,
  payment,
  pbx,
  referral,
  verification,
  voice,
  validator,
  amoWidget,
  integrations,
  hlr,
  'call-tracking': call_tracking,
  'phone-number': phone_number
};
